<template>
  <div class="section-list list-unstyled">
    <section class="section-list-group" :class="sectionClass" v-for="group in groupedItems" :data-group-key="group[0]">
      <slot name="itemHeaderTemplate"
            stickyStyling="position: sticky; top: 0; z-index: 10;"
            :groupKey="group[0]">{{group[0]}}</slot>
      <template v-for="item in group[1]">
        <slot name="itemTemplate" :item="item">
          {{item}}
        </slot>
      </template>
    </section>
  </div>
</template>

<script>
  export default {
    name: "BaseSectionList",
    props: {
      items: {
        type: Array,
        required: true
      },
      groupBy: {
        type: Function | String,
        required: true
      },
      uniqueGroups: {
        type: Boolean,
        default: true,
      },
      sectionClass: {
        type: String | Object,
        default: "",
      },
    },
    computed: {
      groupingFunction() {
        if (typeof this.groupBy === 'string') {
          return item => item[this.groupBy];
        } else {
          return this.groupBy;
        }
      },
      groupedItems() {
        if(this.uniqueGroups)
          return this.items.reduce((group, item) => {
            let groupKey = this.groupingFunction(item);
            if(group.has(groupKey)) {
              group.get(groupKey).push(item)
            } else {
              group.set(groupKey,[item])
            }
            return group
          }, new Map())
        else
          return this.items.reduce((group, item) => {
            let groupKey = this.groupingFunction(item);
            if(group.length > 0 && group[group.length-1][0] === groupKey) {
              group[group.length-1][1].push(item)
            } else {
              group.push([groupKey, [item]])
            }
            return group
          }, [])
      }
    },
  }
</script>

<style scoped>
.section-list {
  display: flex;
  flex-direction: column;
  overflow: auto;
  isolation: isolate;
}
.section-list-group {
  display: flex;
  flex-direction: column;
}
.section-list-header {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>